import { render } from "./FontAwesomeIcon.vue?vue&type=template&id=63e2807f"
import script from "./FontAwesomeIcon.vue?vue&type=script&lang=js"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__